export default function AttrsValueTranslateFilter(gettextCatalog, $filter) {
  'ngInject';

  const isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);

  const translateUOM = (uom, value) => {
    switch (uom) {
      case 'hour':
        return value !== 1 ? gettextCatalog.getString('hours') : gettextCatalog.getString('hour');
      case 'minute':
        return value !== 1
          ? gettextCatalog.getString('minutes')
          : gettextCatalog.getString('minute');
      case 'second':
        return value !== 1
          ? gettextCatalog.getString('seconds')
          : gettextCatalog.getString('second');
      case 'millisecond':
        return value !== 1
          ? gettextCatalog.getString('milliseconds')
          : gettextCatalog.getString('millisecond');
      default:
        return uom;
    }
  };

  const getDuration = (value, uom, includeMilliseconds) => {
    const { years, months, days, hours, minutes, seconds, milliseconds } = moment.duration(
      value,
      uom,
    )._data;
    let data = [];
    if (years) {
      data.push(
        `${years} ${
          years > 1 ? gettextCatalog.getString('years') : gettextCatalog.getString('year')
        }`,
      );
    }
    if (months) {
      data.push(
        `${months} ${
          months > 1 ? gettextCatalog.getString('months') : gettextCatalog.getString('month')
        }`,
      );
    }
    if (days) {
      data.push(
        `${days} ${days > 1 ? gettextCatalog.getString('days') : gettextCatalog.getString('day')}`,
      );
    }
    if (hours) {
      data.push(
        `${hours} ${
          hours > 1 ? gettextCatalog.getString('hours') : gettextCatalog.getString('hour')
        }`,
      );
    }
    if (minutes) {
      data.push(
        `${minutes} ${
          minutes > 1 ? gettextCatalog.getString('minutes') : gettextCatalog.getString('minute')
        }`,
      );
    }
    if (seconds) {
      data.push(
        `${seconds} ${
          seconds > 1 ? gettextCatalog.getString('seconds') : gettextCatalog.getString('second')
        }`,
      );
    }
    if (includeMilliseconds && milliseconds) {
      data.push(
        `${milliseconds} ${
          milliseconds > 1
            ? gettextCatalog.getString('milliseconds')
            : gettextCatalog.getString('millisecond')
        }`,
      );
    }
    return data.join(', ').replace(/,(?=[^,]*$)/, ` ${gettextCatalog.getString('and')}`) || '0';
  };

  const getDate = (value, uom) => {
    const date = new Date('2001-01-01T00:00:00.000Z');
    switch (uom) {
      case 'hour':
        date.setHours(date.getHours() + value);
        break;
      case 'minute':
        date.setMinutes(date.getMinutes() + value);
        break;
      case 'second':
        date.setSeconds(date.getSeconds() + value);
        break;
      case 'millisecond':
        date.setMilliseconds(date.getMilliseconds() + value);
        break;
      default:
        break;
    }
    return $filter('TableDateFilter')(date);
  };

  return function (value, input, hideUOM) {
    if (!input && !value) return '';

    if (!input) return value;

    let uom = null;
    let precision = isNumber(input.decimals) ? input.decimals : 2; //Default precision

    if (!input.attributes) {
      input = {
        attributes: input,
      };
    }

    // Check to see if we have an explicit UOM specified
    if (input.attributes.attrs) {
      if (
        input.attributes.dataId === 'batt_inst_date' ||
        input.attributes.dataId === 'date_ful_char'
      ) {
        value = getDate(value, input.attributes.attrs.uom);
      } else if (
        input.attributes.dataId === 'dur_last_char' ||
        input.attributes.dataId === 'time_sin_last_char'
      ) {
        value = getDuration(value, input.attributes.attrs.uom, false);
      } else if (input.attributes.attrs.uom) {
        uom = translateUOM(input.attributes.attrs.uom, value);
      }
    }

    if (input.attributes.tags) {
      const datapointDescriptor = input.attributes.descriptor;
      // Determine the value based on the presence of tags
      for (let i = 0; i < input.attributes.tags.length; i++) {
        let tag = input.attributes.tags[i];
        if (datapointDescriptor) {
          let useGenericDtc;
          // todo: need more investigation about this section (should be here)
          if (tag === 'dtc') {
            switch (input.attrs['type']) {
              case 'j1939': {
                const { source, type, spn, fmi } = input.attrs;
                const src = source ? `.source:${source}` : '';
                tag += `.type:${type}${src}.spn:${spn}.fmi:${fmi}`;
                break;
              }
              case 'fault': {
                tag += '.type:' + input.attrs['type'] + '.code' + input.attrs['code'];
              }
            }

            useGenericDtc = true;
          }

          if (
            datapointDescriptor &&
            tag === datapointDescriptor.key &&
            datapointDescriptor.values
          ) {
            const valueDescriptor =
              datapointDescriptor.values[value] || datapointDescriptor.values['default'];
            if (valueDescriptor) {
              return gettextCatalog.getString(valueDescriptor);
            }
          }

          if (useGenericDtc) {
            if ('dtc' === datapointDescriptor.key) {
              if (!datapointDescriptor.values[value]) {
                // if there's no descriptor for this value of the datapoint, output the default or raw value
                if (datapointDescriptor.values['default']) {
                  return datapointDescriptor.values['default'];
                } else {
                  return value;
                }
              }
              return datapointDescriptor.values[value];
            }
          }
        }
        if (tag === 'gps') {
          return value ? `${value[1]} , ${value[0]}` : gettextCatalog.getString('Not available');
        }
      }
    }

    // Round the result if its a number (precision may change dependent on tag)
    if (isNumber(value)) {
      value = Number.isInteger(Number(value)) ? value : value.toFixed(precision);
    }

    return uom && !hideUOM ? `${value} ${uom}` : value;
  };
}
